var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-text-value-list');
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { entityPluralLabel } from '../../utils/entity-plural-label';
export var EntityTextValueListDefaultProps = {
  labelColor: 'text-subtle'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n    font-size: ", ";\n    &:first-child {\n      margin-top: ", ";\n    }\n  "], ["\n    margin-top: ", ";\n    font-size: ", ";\n    &:first-child {\n      margin-top: ", ";\n    }\n  "])), theme.UNIT(3), theme.FONT_SIZE(14), theme.UNIT(1))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    font-size: 1em;\n    padding-right: ", ";\n\n    ", "\n  "], ["\n    display: inline-block;\n    font-size: 1em;\n    padding-right: ", ";\n\n    ", "\n  "])), theme.UNIT(2), function (_a) {
    var _color = _a._color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR(_color));
  })
});
var ValueStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Values: styled.span.attrs(cls.attr('values'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
export var EntityTextValueList = function EntityTextValueList(props) {
  var className = props.className,
      children = props.children,
      _a = props.items,
      items = _a === void 0 ? [] : _a;
  var hasItems = !!items.length;
  var label = props.label || hasItems && entityPluralLabel(items[0]) + ":";

  if (!hasItems) {
    return null;
  }

  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, {
    _color: props.labelColor
  }, label), items.map(function (item) {
    return item.name;
  }).join(', '));
};
EntityTextValueList.defaultProps = EntityTextValueListDefaultProps;
EntityTextValueList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;